import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41a8c813")

_pushScopeId("data-v-41a8c813")
const _hoisted_1 = {
  key: 0,
  class: "UploadedFiles"
}
const _hoisted_2 = { class: "UploadedFiles__title" }
const _hoisted_3 = {
  key: 0,
  class: "UploadedFiles__holder"
}
const _hoisted_4 = { class: "item__actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_i_download = _resolveComponent("i-download")!
  const _component_s_icon_button = _resolveComponent("s-icon-button")!
  const _component_i_trash = _resolveComponent("i-trash")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.isVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.files, (file, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: `uploaded-file-${idx}`,
                  class: ["UploadedFiles__item", { 'UploadedFiles__item-white': _ctx.isWhite }]
                }, [
                  _createTextVNode(_toDisplayString(file.original_name || 'Файл без имени') + " ", 1),
                  _createVNode("div", _hoisted_4, [
                    _createVNode("a", {
                      href: file.path,
                      target: "_blank"
                    }, [
                      _createVNode(_component_s_icon_button, {
                        class: "actions__button",
                        content: "Скачать файл"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_i_download)
                        ]),
                        _: 1
                      })
                    ], 8, ["href"]),
                    (!_ctx.noDelete)
                      ? (_openBlock(), _createBlock(_component_s_icon_button, {
                          key: 0,
                          class: "actions__button",
                          content: "Удалить файл",
                          loading: _ctx.loading,
                          onClick: ($event: any) => (_ctx.deleteFile(file.id, idx))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_i_trash)
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})